







































































































































































import { Component, Vue } from 'vue-property-decorator';
import Car from '@/entities/Car';
import TimeLeft from '@/components/TimeLeft.vue';
import BuyNow from '@/components/buttons/BuyNow.vue';
import Gallery from '@/components/Gallery.vue';
import Variables from '@/config/variables';
import BidService from '@/services/bid';
import CarService from '@/services/car';
import Bid from '@/entities/Bid';
import AuthService from '@/services/auth';
import ModalService from '@/services/modal';
import Formatter from '@/support/formatter';
import Logo from '@/components/svg/Logo.vue';
import LanguageService from '@/services/language';

@Component({
    components: {
        BuyNow,
        TimeLeft,
        Gallery,
        Logo,
    },
})
export default class CarDetails extends Vue {
    authService = new AuthService();

    bidService = new BidService();

    carService = new CarService();

    modalService = new ModalService();

    variables = new Variables();

    formatter = new Formatter();

    languageService = new LanguageService();

    car: Car = null;

    error = false;

    price: number = null;

    currentBid: number = null;

    loading = true;

    get isOwnBid(): boolean {
        return this.bidService.isOwnBid(this.car.id, this.car.highestBid);
    }

    get ownBid(): Bid {
        return this.bidService.findOwnBid(this.car.id);
    }

    mounted(): void {
        this.loading = true;
        this.carService.get(this.$route.params.uuid)
            .then((car) => {
                this.car = car;
                this.currentBid = car.nextLowestBid;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    submitBid(callback: any) {
        if (this.currentBid >= this.car.nextLowestBid) {
            this.car.highestBid = Math.ceil(this.currentBid);

            this.$nextTick(() => {
                this.currentBid = this.car.nextLowestBid;
            });
        }

        if (callback) {
            callback();
        }
    }

    public addBid() {
        const amountToSubmit = this.currentBid;
        if (amountToSubmit < this.car.nextLowestBid) {
            return this.modalService.showInfoModal(
                this.$t('bid.low_amount.title').toString(),
                this.$t('bid.low_amount.content', {
                    amount: this.formatter.currency(amountToSubmit),
                    minimumAmount: this.formatter.currency(this.car.nextLowestBid),
                }).toString(),
            );
        }
        if (!this.authService.isLoggedIn) {
            return this.modalService.showLoginModal();
        }
        if (!this.authService.currentUser.canBuy) {
            return this.modalService.showNeedProfileUpdateModal();
        }

        return this.modalService.showConfirmationModal(
            this.$t('bid.confirm.title').toString(),
            this.getConfirmBidContent(amountToSubmit),
            () => this.congratulate(amountToSubmit),
        );
    }

    private getConfirmBidContent(amountToSubmit: number): string {
        const calculated = this.bidService.calculate(amountToSubmit, this.car);

        return `
            <div>${this.$t('details.your_bid')}: <strong>${calculated.amount.formatted}</strong></div>
            <div class="${this.car.vatDeductible ? '' : 'hidden'}">${this.$t('details.vat', { vat: this.variables.vat })}: <strong>${calculated.vat.formatted}</strong></div>
            <div>${this.$t('details.fee')}: <strong>${calculated.fee.formatted}</strong></div>
            <div class="mb-4">${this.$t('details.grand_total')}: <strong>${calculated.total.formatted}</strong></div>
            ${this.$t('bid.confirm.content', { amount: this.formatter.currency(amountToSubmit) })}
        `;
    }

    public congratulate(amount: number) {
        this.submitBid(() => {
            this.bidService.addBid(this.car.id, this.currentBid)
                .then(() => {
                    this.modalService.showInfoModal(
                        this.$t('bid.congratulate.title').toString(),
                        this.$t('bid.congratulate.content', { amount: this.formatter.currency(amount) }).toString(),
                    );
                });
        });
    }
}
